import React, { useEffect, useState } from 'react'
// import AboutImage from '../assets/images/7922055.jpg';
import AnimateOnScroll from '../components/ScrollAnimations/AnimateOnScroll';
import Button2 from '../components/Buttons/Button2/Button2';
import image1 from '../assets/images/think-bigger-image-1.png'
// import image1 from ''
// import ServicesComponent from '../components/HomePage/Services/ServicesComponent';
import AboutCompImage from '../assets/images/about-us-image1.jpeg';


const words = ["App Developer", "Web Developer", "API Developer"]; // Fixed typo from "Desinger"




const About = () => {


  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length);
        setFade(true);
      }, 500); // duration of fade-out
    }, 3000); // total interval time

    return () => clearInterval(interval);
  }, []);



  return (
    <>
      <div className="container">
        <div className='main-about'>
          <div>
            <AnimateOnScroll>
              <p className="base_heading_2">A Team That Thinks Like Partners.</p>
              <p className="base_heading_2">Not Vendors</p>
              <p className="base_heading_2" id="words" style={{ opacity: fade ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }}>{words[currentIndex]}</p>
              <p className="base_p_tag">In it with you. Aligned, invested, and focused on what actually moves the needle.</p>
            </AnimateOnScroll>

            <AnimateOnScroll>
              <Button2 text="Explore Our Services" link="/services" />
            </AnimateOnScroll>
          </div>
        </div>
      </div>

      <div className="container main-about-2">
        <div className="left-div">
          <AnimateOnScroll delay={0.5}>
          <img src={AboutCompImage} alt="" srcSet="" />
          </AnimateOnScroll>
        </div>
        <div className="right-div">
          <AnimateOnScroll delay={0.5}>
          <div><p className="base_heading_2">Why Clients <span className="blue-span">Trust Infiniese</span></p></div>
          </AnimateOnScroll>
          <AnimateOnScroll delay={0.5}>
            <div className='think-bigger-cards'>
              <div className="think-bigger-card">
                <div className="think-bigger-card-image">
                  <img src={image1} alt="" srcSet="" />
                </div>
                <div className="think-bigger-card-content">
                  <p className="base_heading_2">We Build, You Shine</p>
                  <p className="base_p_tag">Our mission is simple - your success is our portfolio. Every project we create is designed to make your brand stand out in the digital crowd.</p>
                </div>
              </div>
              <div className="think-bigger-card">
                <div className="think-bigger-card-image">
                  <img src={image1} alt="" srcSet="" />
                </div>
                <div className="think-bigger-card-content">
                  <p className="base_heading_2">Ideas to Reality</p>
                  <p className="base_p_tag">Got a raw idea? We turn it into a functional, stunning digital product. From concept to launch, we shape your vision into reality.</p>
                </div>
              </div>
              <div className="think-bigger-card">
                <div className="think-bigger-card-image">
                  <img src={image1} alt="" srcSet="" />
                </div>
                <div className="think-bigger-card-content">
                  <p className="base_heading_2">Detail-Obsessed</p>
                  <p className="base_p_tag">Pixel-perfect design, smooth performance, and flawless user experience - we care about the little things that make a big impact.</p>
                </div>
              </div>
              <div className="think-bigger-card">
                <div className="think-bigger-card-image">
                  <img src={image1} alt="" srcSet="" />
                </div>
                <div className="think-bigger-card-content">
                  <p className="base_heading_2">Beyond Just Code</p>
                  <p className="base_p_tag">We don't just deliver websites and apps; we craft digital experiences that connect with people and drive real business growth.</p>
                </div>
              </div>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </>
  )
}

export default About